import React, { Component } from "react";
import {
  Row,
  Form,
  Col,
  InputGroup,
  Button,
  FormControl,
} from "react-bootstrap";
import "../asserts/css/style.css";
import DatePicker from "react-datepicker";
import * as publicUtils from "./utils/publicUtils.js";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo, faSearch } from "@fortawesome/free-solid-svg-icons";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import axios from "axios";
import ErrorsMessageToast from "./errorsMessageToast";
import { Link } from "react-router-dom";
import store from "./redux/store";
import {
  dropDownRow,
  dropDownRowSlice,
  dropDownServerBase,
} from "./utils/dropDownSafe";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { alignPropType } from "react-bootstrap/esm/DropdownMenu";
axios.defaults.withCredentials = true;

class monthlySalesSearch extends Component {
  //月次売上検索
  state = {
    monthlySales_YearAndMonth: "",
    monthlySales_startYearAndMonth: "",
    monthlySales_endYearAndMonth: "",
    utilPricefront: "",
    utilPriceback: "",
    salaryfront: "",
    salaryback: "",
    grossProfitFront: "",
    grossProfitBack: "",
    nowYandM: "",
    kadou: "",
    rowSelectemployeeNo: "",
    rowSelectemployeeName: "",
    sendFlag: "",
    rowNo: "",
    bpFlag: false,
    authorityCode: '',
  };
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.valueChange = this.valueChange.bind(this);
    this.getAuthorityCode = this.getAuthorityCode.bind(this);
    this.options = {
      sizePerPage: 12,
      pageStartIndex: 1,
      paginationSize: 3,
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      hideSizePerPage: true,
      hideSizePerPage: true,
      alwaysShowAllBtns: true,
      paginationShowsTotal: this.renderShowsTotal,
      onPageChange: (page) => this.setState({ currentPage: page }),
      expandRowBgColor: "rgb(165, 165, 165)",
    };
  }

  initialState = {
    currentPage: 1,
    rowNo: "",
    employeeStatuss: store.getState().dropDown[4],
    employeeFormCodes: store.getState().dropDown[2],
    occupationCodes: store.getState().dropDown[10],
    serverIP: store.getState().dropDown[store.getState().dropDown.length - 1],
    rowSelectemployeeNo: "",
    monthlySales_startYearAndMonth: new Date(),
    monthlySales_endYearAndMonth: new Date(),
    employeeInfoAll: dropDownRowSlice(store.getState().dropDown, 9),
    employeeInfo: dropDownRowSlice(store.getState().dropDown, 9),
    employeeName: "",
    searchEmployeeNo: "",
    bpBusinessSalesTotal: "",
    salesStaff: "",
    customerNo: "",
    customerMaster: dropDownRow(store.getState().dropDown, 15).filter(
      (item) => item.code
    ),
    salesPersons: dropDownRow(store.getState().dropDown, 56).filter(
      (item) => item.code
    ),
    kadou: "0"
  };

  getAuthorityCode = async () => {
    axios
      .post(this.state.serverIP + "sendLettersConfirm/getLoginUserInfo")
      .then((result) => {
        this.setState({
          authorityCode: result.data[0].authorityCode,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  componentDidMount() {
    this.getAuthorityCode();

    var date = new Date();
    var year = date.getFullYear();
    $("#fiscalYear").append('<option value="">' + "" + "</option>");
    for (var i = year - 1; i <= year + 1; i++) {
      $("#fiscalYear").append('<option value="' + i + '">' + i + "</option>");
    }
    let employeeStatuss = [];
    for (let i in this.state.employeeStatuss) {
      if (this.state.employeeStatuss[i].code !== "4") {
        employeeStatuss.push(this.state.employeeStatuss[i]);
      }
    }
    this.setState({
      employeeStatuss: employeeStatuss,
    });
    this.clickButtonDisabled();
    const { location } = this.props;
    if (location.state) {
      let data = location.state;
      if (data.sendValue !== undefined && data.sendValue !== null) {
        data = data.sendValue;
        $("#personalSearchBtn").removeClass("disabled");
      }
      this.setState(
        {
          monthlySales_startYearAndMonth: data.monthlySales_startYearAndMonth,
          monthlySales_endYearAndMonth: data.monthlySales_endYearAndMonth,
          //employeeClassification:this.state.employeeClassification === "" ? "" :data.employeeClassification,
          // employeeFormCodes:this.state.employeeFormCodes === "" ? "" :data.employeeFormCodes,
          // occupationCodes:this.state.occupationCodes === "" ? "" :data.occupationCodes,
          // kadou:this.state.kadou === "" ? "" :data.kadou,
          utilPricefront:
            this.state.utilPricefront === "" ? "" : data.utilPricefront,
          utilPriceback:
            this.state.utilPriceback === "" ? "" : data.utilPriceback,
          salaryfront: this.state.salaryfront === "" ? "" : data.salaryfront,
          salaryback: this.state.salaryback === "" ? "" : data.salaryback,
          grossProfitFront:
            this.state.grossProfitFront === "" ? "" : data.grossProfitFront,
          grossProfitBack:
            this.state.grossProfitBack === "" ? "" : data.grossProfitBack,
          rowSelectemployeeNo: data.rowSelectemployeeNo,
          fiscalYear: data.fiscalYear,
          kadou: data.kadou,
          employeeClassification: data.employeeClassification,
          employeeForms: data.employeeForms || "",
          employeeName: data.employeeName || "",
          searchEmployeeNo: data.searchEmployeeNo || "",
          employeeOccupation: data.employeeOccupation,
          rowNo: data.rowNo,
          salesStaff: data.salesStaff || "",
          customerNo: data.customerNo || "",
        },
        () => this.searchMonthlySales(data)
      );
    } else {
      this.searchMonthlySales();
    }
  }

  clickButtonDisabled = () => {
    $('button[name="personalSearchBtn"]').prop("disabled", true);
  };
  //onchange
  valueChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  renderShowsTotal(start, to, total) {
    return (
      <p
        style={{
          color: "dark",
          float: "left",
          display: total > 0 ? "block" : "none",
        }}
      >
        {start}から {to}まで , 総計{total}
      </p>
    );
  }

  vNumberChange = (e, key) => {
    const { value } = e.target;

    const reg = /^[0-9]*$/;
    if (reg.test(value) && value.length < 4) {
      this.setState({
        [key]: value,
      });
    }
  };
  monthlySalesStartYearAndMonthChange = (date) => {
    if (date !== null) {
      this.setState({
        monthlySales_startYearAndMonth: date,
        fiscalYear: "",
      });
    } else {
      this.setState({
        monthlySales_startYearAndMonth: "",
      });
    }
  };

  monthlySalesEndYearAndMonthChange = (date) => {
    if (date !== null) {
      this.setState({
        monthlySales_endYearAndMonth: date,
        fiscalYear: "",
      });
    } else {
      this.setState({
        monthlySales_endYearAndMonth: "",
      });
    }
  };
  searchMonthlySales = (restoreState = null) => {
    const restorePage = restoreState && Number.isInteger(restoreState.currentPage)
      ? Math.max(1, restoreState.currentPage)
      : 1;
    const restoreRowNo = restoreState && restoreState.rowNo;
    let employeeOccupation = this.state.employeeOccupation;
    if (this.state.employeeClassification === "1") {
      this.setState({ bpFlag: true });
      employeeOccupation = "";
    } else {
      this.setState({ bpFlag: false });
    }
    const monthlyInfo = {
      employeeClassification: this.state.employeeClassification,
      employeeForms: this.state.employeeForms,
      employeeOccupation: employeeOccupation,
      employeeNo: this.state.searchEmployeeNo,
      salesStaff: this.state.salesStaff,
      customerNo: this.state.customerNo,
      kadou: this.state.kadou,
      utilPricefront: this.state.utilPricefront,
      utilPriceback: this.state.utilPriceback,
      salaryfront: this.state.salaryfront,
      salaryback: this.state.salaryback,
      grossProfitFront: this.state.grossProfitFront,
      grossProfitBack: this.state.grossProfitBack,
      startYandM: publicUtils.formateDate(
        this.state.monthlySales_startYearAndMonth,
        false
      ),
      endYandM: publicUtils.formateDate(
        this.state.monthlySales_endYearAndMonth,
        false
      ),
      fiscalYear: this.state.fiscalYear,
    };
    axios
      .post(
        this.state.serverIP + "monthlySales/searchMonthlySales",
        monthlyInfo
      )
      .then((response) => {
        console.log("monthlyInfo =", monthlyInfo);
        if (response.data.errorsMessage != null) {
          this.setState({
            errorsMessageShow: true,
            errorsMessageValue: response.data.errorsMessage,
          });
          this.setState({ monthlySalesInfoList: [], currentPage: 1, rowNo: "", rowSelectemployeeNo: "" });
          this.setState({
            unitPirceTotal: "",
            bpBusinessSalesTotal: "",
            salaryTotal: "",
            TotalNonOperation: "",
            grossProfitTotal: "",
          });
        } else if (response.data.noData != null) {
          this.setState({
            errorsMessageShow: true,
            errorsMessageValue: response.data.noData,
          });
          this.setState({ monthlySalesInfoList: [], currentPage: 1, rowNo: "", rowSelectemployeeNo: "" });
          this.setState({
            unitPirceTotal: "",
            bpBusinessSalesTotal: "",
            salaryTotal: "",
            TotalNonOperation: "",
            grossProfitTotal: "",
          });
        } else {
          this.setState({ errorsMessageShow: false });
          const rows = response.data.data;
          const selectedRow = restoreRowNo
            ? rows.find((row) =>
                Number(row.rowNo) === Number(restoreRowNo) &&
                row.employeeNo === restoreState.rowSelectemployeeNo
              )
            : null;
          const currentPage = Math.min(
            restorePage,
            Math.max(1, Math.ceil(rows.length / this.options.sizePerPage))
          );
          this.setState(
            {
              monthlySalesInfoList: rows,
              currentPage,
              rowNo: selectedRow ? selectedRow.rowNo : "",
              rowSelectemployeeNo: selectedRow ? selectedRow.employeeNo : "",
              rowSelectemployeeName: selectedRow ? selectedRow.employeeName : "",
            },
            this.totalfee
          );
        }
        console.log("employeeName:", this.state.employeeName);
      })
      .catch((error) => {
        console.error("Error - " + error);
      });
  };
  resetForm = () => {
    this.setState({
      salesStaff: "",
      customerNo: "",
      monthlySales_startYearAndMonth: "",
      monthlySales_endYearAndMonth: "",
      employeeClassification: "",
      employeeForms: "",
      employeeOccupation: "",
      kadou: "",
      utilPricefront: "",
      utilPriceback: "",
      salaryfront: "",
      salaryback: "",
      grossProfitFront: "",
      grossProfitBack: "",
      fiscalYear: "",
    });
  };
  totalfee = () => {
    let unitPirceTotal = 0;
    let bpBusinessSalesTotal = 0;
    let salaryTotal = 0;
    let TotalNonOperation = 0;
    let grossProfitTotal = 0;
    let workcount = 0;
    for (let i = 0; i < this.state.monthlySalesInfoList.length; i++) {
      workcount++;
      if (
        this.state.monthlySalesInfoList[i].unitPrice == null ||
        this.state.monthlySalesInfoList[i].unitPrice == ""
      ) {
        unitPirceTotal = parseInt(unitPirceTotal) + 0;
      } else {
        if (
          this.state.monthlySalesInfoList[i]
            .deductionsAndOvertimePayOfUnitPrice === null ||
          this.state.monthlySalesInfoList[i]
            .deductionsAndOvertimePayOfUnitPrice === ""
        ) {
          unitPirceTotal =
            parseInt(unitPirceTotal) +
            parseInt(this.state.monthlySalesInfoList[i].unitPrice);
        } else {
          unitPirceTotal =
            parseInt(unitPirceTotal) +
            parseInt(this.state.monthlySalesInfoList[i].unitPrice) +
            parseInt(
              this.state.monthlySalesInfoList[i]
                .deductionsAndOvertimePayOfUnitPrice
            );
        }
      }
      if (
        ["1", "2", "4"].includes(
          String(this.state.monthlySalesInfoList[i].employeeStatus)
        )
      ) {
        const salary = Number(this.state.monthlySalesInfoList[i].salary);
        if (Number.isFinite(salary)) {
          salaryTotal += salary;
        }
        const unitPrice = Number(this.state.monthlySalesInfoList[i].unitPrice);
        if (Number.isFinite(unitPrice)) {
          bpBusinessSalesTotal += unitPrice;
        }
        const grossProfit = Number(
          this.state.monthlySalesInfoList[i].monthlyGrosProfits
        );
        if (Number.isFinite(grossProfit)) {
          grossProfitTotal += grossProfit;
        }
      }
      if (
        this.state.monthlySalesInfoList[i].waitingCost == null ||
        this.state.monthlySalesInfoList[i].waitingCost == ""
      ) {
        TotalNonOperation = parseInt(TotalNonOperation) + 0;
      } else {
        TotalNonOperation =
          parseInt(TotalNonOperation) +
          parseInt(this.state.monthlySalesInfoList[i].waitingCost);
      }

    }
    this.setState({
      unitPirceTotal: publicUtils.addComma(unitPirceTotal.toString(), false),
      bpBusinessSalesTotal: publicUtils.addComma(
        bpBusinessSalesTotal.toString(),
        false
      ),
    });
    this.setState({
      salaryTotal: publicUtils.addComma(salaryTotal.toString(), false),
    });
    this.setState({
      TotalNonOperation: publicUtils.addComma(
        TotalNonOperation.toString(),
        false
      ),
    });
    this.setState({
      grossProfitTotal: publicUtils.addComma(
        grossProfitTotal.toString(),
        false
      ),
    });
    this.setState({ workcount: workcount });
  };

  formatStayPeriod(code) {
    let positionsTem = this.state.employeeStatuss;
    for (var i in positionsTem) {
      if (code === positionsTem[i].code) {
        return positionsTem[i].name;
      }
    }
  }

  employeeNameFormat = (cell, row) => {
    const employeeName = String(row.employeeStatus) === "2" ? `${cell}（SP）` : cell;
    if (row.customerAbbreviation) {
        return `${employeeName}(${row.customerAbbreviation})`;
    }
    return employeeName;
  }

  lycStartYearAndMonthFormat(cell, row) {
    if (!cell || cell.length < 6) {
      return "";
    }
    const yearAndMonth = `${cell.substring(0, 4)}/${cell.substring(4, 6)}`;
    const customerAbbreviation = (row.lycStartCustomerAbbreviation || "").trim();
    return customerAbbreviation
      ? `${yearAndMonth}（${customerAbbreviation}）`
      : yearAndMonth;
  }

  admissionStartDateFormat = (cell, row) => {
    if (!cell || cell.length < 8) {
        return "";
    }

    const admissionDate = `${cell.substring(0, 4)}/${cell.substring(4, 6)}/${cell.substring(6, 8)}`;
    const yearAndMonth = row.yearAndMonth || "";
    if (!/^\d{6}$/.test(yearAndMonth) || !/^\d{8}$/.test(cell)) {
      return admissionDate;
    }
    const startMonth = Number(cell.substring(4, 6));
    const endMonth = Number(yearAndMonth.substring(4, 6));
    if (startMonth < 1 || startMonth > 12 || endMonth < 1 || endMonth > 12) {
      return admissionDate;
    }
    const months =
      (Number(yearAndMonth.substring(0, 4)) - Number(cell.substring(0, 4))) * 12 +
      endMonth - startMonth + 1;
    if (months < 1) {
      return admissionDate;
    }
    return (
      <span>
        {admissionDate}（<span style={{ color: "red" }}>{months}</span>ヶ月）
      </span>
    );
  };

  unitPriceAddComma(cell, row) {
    if (row.unitPrice === null || row.unitPrice === 0) {
      return;
    } else {
      const taxLabel = String(row.employeeStatus) === "2" ? "（税込み）" : "";
      const formatUprice = `${publicUtils.addComma(row.unitPrice, false)}${taxLabel}`;
      const unitPrice = Number(row.unitPrice);
      const unitPriceStyle = {
        color: unitPrice >= 700000 ? "#d95f3b" : unitPrice < 500000 ? "#1565c0" : undefined,
        fontWeight: unitPrice >= 700000 || unitPrice < 500000 ? 600 : undefined,
      };
      if (row.deductionsAndOvertimePayOfUnitPrice != null) {
        if (row.deductionsAndOvertimePayOfUnitPrice < 0) {
          return (
            <div>
              <div style={{ ...unitPriceStyle, float: "left" }}>
                {formatUprice}
              </div>
              <div style={{ color: "red", float: "left" }}>
                (
                {publicUtils.addComma(
                  row.deductionsAndOvertimePayOfUnitPrice,
                  false
                )}
                )
              </div>
            </div>
          );
        }
      }
      if (row.dailyCalculationStatus == "0") {
        return (
          <div>
            <span style={unitPriceStyle}>{formatUprice}</span>
            <font color="red">(日割)</font>
          </div>
        );
      } else {
        return <span style={unitPriceStyle}>{formatUprice}</span>;
      }
    }
  }

  /**
   * 社員名連想
   *
   * @param {}
   *            event
   */
  getEmployeeName = (event, values) => {
    if (values != null) {
        this.setState({
            employeeName: values.text,
            searchEmployeeNo: values.code,
        });
    } else {
        this.setState({
            employeeName: "",
            searchEmployeeNo: "",
        });
    }
};

  employeeStatusChange = (event) => {
    const value = event.target.value;
    const employeeInfoList = this.state.employeeInfoAll;
    let newEmpInfoList = [];

    if (value === "0") {
        // 普通社員：排除 BP / SP / SC
        for (let i in employeeInfoList) {
            if (
                employeeInfoList[i].code.substring(0, 2) !== "BP" &&
                employeeInfoList[i].code.substring(0, 2) !== "SP" &&
                employeeInfoList[i].code.substring(0, 2) !== "SC"
            ) {
                newEmpInfoList.push(employeeInfoList[i]);
            }
        }
    } else if (value === "1") {
        // BP
        for (let i in employeeInfoList) {
            if (employeeInfoList[i].code.substring(0, 2) === "BP") {
                newEmpInfoList.push(employeeInfoList[i]);
            }
        }
    } else if (value === "2") {
        // SP
        for (let i in employeeInfoList) {
            if (employeeInfoList[i].code.substring(0, 2) === "SP") {
                newEmpInfoList.push(employeeInfoList[i]);
            }
        }
    } else if (value === "3") {
        // SC
        for (let i in employeeInfoList) {
            if (employeeInfoList[i].code.substring(0, 2) === "SC") {
                newEmpInfoList.push(employeeInfoList[i]);
            }
        }
    } else if (value === "4") {
        // BPR
        for (let i in employeeInfoList) {
            if (employeeInfoList[i].code.substring(0, 3) === "BPR") {
                newEmpInfoList.push(employeeInfoList[i]);
            }
        }
    } else if (value === "5") {
        // BP以外
        for (let i in employeeInfoList) {
            if (employeeInfoList[i].code.substring(0, 2) !== "BP") {
                newEmpInfoList.push(employeeInfoList[i]);
            }
        }
    } else {
        // 未指定 → 全員
        newEmpInfoList = employeeInfoList;
    }

    this.setState({
        employeeClassification: value,
        employeeInfo: newEmpInfoList,
        employeeName: "",
        searchEmployeeNo: "",
    });
  };

  salaryAddComma(cell, row) {
    if (row.employeeStatus === "0") {
        return "";
    }
    if (row.salary === null || row.salary === 0) {
      return;
    } else {
      let formatSalary;
      if (row.deductionsAndOvertimePay != null) {
        if (row.deductionsAndOvertimePay < 0) {
          return (
            <div>
              <div style={{ float: "left" }}>
                {publicUtils.addComma(row.salary, false)}
              </div>
              <div style={{ color: "red", float: "left" }}>
                ({publicUtils.addComma(row.deductionsAndOvertimePay, false)})
              </div>
            </div>
          );
        }
      } /*else{*/
      formatSalary = publicUtils.addComma(row.salary, false);
      /*}*/

      return formatSalary;
    }
  }

  otherFeeAddComma(cell, row) {
    if (row.otherFee === null || row.otherFee === 0) {
      return;
    } else {
      let formatOtherFee = publicUtils.addComma(row.otherFee, false);
      return formatOtherFee;
    }
  }

  waitingCostAddComma(cell, row) {
    if (row.waitingCost === null || row.waitingCost === 0) {
      return;
    } else {
      let formatwaitingCost = publicUtils.addComma(row.waitingCost, false);
      if (row.waitingCost === "0") {
        return "";
      } else {
        return formatwaitingCost;
      }
    }
  }

  monthlyGrosProfitsAddComma(cell, row) {
    if (row.employeeStatus === "0") {
        return "";
    }
    if (row.monthlyGrosProfits === null || row.monthlyGrosProfits === 0) {
      return;
    } else {
      let mGrosProfits = row.monthlyGrosProfits.split(".")[0];
      let formatmGrosProfits = publicUtils.addComma(mGrosProfits, false);
      if (row.monthlyGrosProfits < 0) {
        return <div style={{ color: "red" }}>{formatmGrosProfits}</div>;
      }
      return formatmGrosProfits;
    }
  }

  rowNoFormat(cell, row) {
    return String(cell).padStart(3, "0");
  }
  handleRowSelect = (row, isSelected, e) => {
    if (isSelected) {
      this.setState({ rowSelectemployeeNo: row.employeeNo, rowNo: row.rowNo });
      this.setState({ rowSelectemployeeName: row.employeeName });
      $("#personalSearchBtn").removeClass("disabled");
    } else {
      this.setState({ rowSelectemployeeNo: "", rowNo: "" });
      $("#personalSearchBtn").addClass("disabled");
    }

    console.log(row);
  };

  yearAndMonthChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      monthlySales_startYearAndMonth: "",
      monthlySales_endYearAndMonth: "",
    });
  };

  shuseiTo = (actionType) => {
    var path = {};
    const sendValue = {
      currentPage: this.state.currentPage,
      employeeName: this.state.employeeName,
      searchEmployeeNo: this.state.searchEmployeeNo,
      employeeForms: this.state.employeeForms,
      monthlySales_startYearAndMonth: this.state.monthlySales_startYearAndMonth,
      monthlySales_endYearAndMonth: this.state.monthlySales_endYearAndMonth,
      utilPricefront: this.state.utilPricefront,
      utilPriceback: this.state.utilPriceback,
      salaryfront: this.state.salaryfront,
      salaryback: this.state.salaryback,
      grossProfitFront: this.state.grossProfitFront,
      grossProfitBack: this.state.grossProfitBack,
      fiscalYear: this.state.fiscalYear,
      kadou: this.state.kadou,
      employeeClassification: this.state.employeeClassification,
      employeeOccupation: this.state.employeeOccupation,
      rowNo: this.state.rowNo,
      rowSelectemployeeNo: this.state.rowSelectemployeeNo,
      salesStaff: this.state.salesStaff,
      customerNo: this.state.customerNo,
    };

    switch (actionType) {
      case "siteInfo":
        path = {
          pathname: "/subMenuManager/siteInfo",
          state: {
            employeeNo: this.state.rowSelectemployeeNo,
            backPage: "monthlySalesSearch",
            sendValue: sendValue,
            searchFlag: this.state.searchFlag,
          },
        };
        break;
      case "detail":
        path = {
          pathname: "/subMenuManager/employeeUpdateNew",
          state: {
            actionType: "update",
            id: String(this.state.rowSelectemployeeNo),
            backPage: "monthlySalesSearch",
            sendValue: sendValue,
          },
        };
        break;
    }
    this.props.history.push(path);
  };

  render() {
    const {
      kadou,
      employeeOccupation,
      employeeForms,
      employeeClassification,
      errorsMessageValue,
      employeeStatuss,
      employeeFormCodes,
      occupationCodes,
    } = this.state;
    const selectRow = {
      mode: "radio",
      selected: this.state.rowNo ? [this.state.rowNo] : [],
      bgColor: "pink",
      hideSelectColumn: true,
      clickToSelect: true,
      clickToExpand: true,
      onSelect: this.handleRowSelect,
    };
    return (
      <div>
        <div
          style={{ display: this.state.errorsMessageShow ? "block" : "none" }}
        >
          <ErrorsMessageToast
            errorsMessageShow={this.state.errorsMessageShow}
            message={errorsMessageValue}
            type={"danger"}
          />
        </div>
        <Form>
          <Row inline="true">
            <Col className="text-center">
              <h2>全員売上検索</h2>
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-sm">
                    社員区分
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as="select"
                  size="sm"
                  onChange={this.employeeStatusChange}
                  name="employeeClassification"
                  id="employeeClassification"
                  value={employeeClassification}
                  autoComplete="off"
                >
                  {employeeStatuss.map((data) => (
                    <option key={data.code} value={data.code}>
                      {data.name}
                    </option>
                  ))}
                </Form.Control>
              </InputGroup>
            </Col>
            <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="fiveKanji">
                    社員名
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Autocomplete
                  className="fx1"
                  id="employeeName"
                  name="employeeName"
                  value={
                    this.state.employeeInfo.find(
                      (v) => v.text === this.state.employeeName
                    ) || {}
                  }
                  options={this.state.employeeInfo}
                  getOptionLabel={(option) => option.name || ""}
                  // onSelect={(event) =>
                  //   this.handleTag(event, "employeeName")
                  // }
                  onChange={(event, values) =>
                    this.getEmployeeName(event, values)
                  }
                  renderOption={(option) => {
                    return (
                      <React.Fragment>{option.name || ""}</React.Fragment>
                    );
                  }}
                  renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                      <input
                        type="text"
                        {...params.inputProps}
                        className="auto form-control Autocompletestyle-siteInfoSearch-employeeNo w100p"
                      />
                    </div>
                  )}
                />
              </InputGroup>
            </Col>
            <Col sm={3}>
              <div className="d-flex">
                <InputGroup
                  size="sm"
                  className="mb-3 flex-nowrap"
                  style={{ flex: "0 0 7rem", marginRight: "0.5rem" }}
                >
                  <InputGroup.Prepend>
                    <InputGroup.Text style={{ width: "auto", whiteSpace: "nowrap" }}>
                      稼働
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    as="select"
                    size="sm"
                    onChange={this.valueChange}
                    name="kadou"
                    id="kadou"
                    value={kadou}
                    autoComplete="off"
                  >
                    <option value=""></option>
                    <option value="0">はい</option>
                    <option value="1">いいえ</option>
                  </Form.Control>
                </InputGroup>
                <InputGroup
                  size="sm"
                  className="mb-3 flex-nowrap"
                  style={{ flex: "1 1 0", minWidth: 0 }}
                >
                  <InputGroup.Prepend>
                    <InputGroup.Text style={{ width: "auto", whiteSpace: "nowrap" }}>
                      お客様
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <Autocomplete
                    className="fx1"
                    style={{ minWidth: 0 }}
                    id="customerNo"
                    options={this.state.customerMaster}
                    value={
                      this.state.customerMaster.find(
                        (item) => item.code === this.state.customerNo
                      ) || null
                    }
                    getOptionLabel={(option) => option.name || ""}
                    getOptionSelected={(option, value) => option.code === value.code}
                    onChange={(event, value) =>
                      this.setState({ customerNo: value ? value.code : "" })
                    }
                    renderInput={(params) => (
                      <div ref={params.InputProps.ref}>
                        <input
                          type="text"
                          {...params.inputProps}
                          className="auto form-control Autocompletestyle-siteInfoSearch-customerNo w100p"
                        />
                      </div>
                    )}
                  />
                </InputGroup>
              </div>
            </Col>
            <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text>営業担当</InputGroup.Text>
                </InputGroup.Prepend>
                <Autocomplete
                  className="fx1"
                  id="salesStaff"
                  value={
                    this.state.salesPersons.find(
                      (item) => item.code === this.state.salesStaff
                    ) || null
                  }
                  options={this.state.salesPersons}
                  getOptionLabel={(option) => option.name || ""}
                  onChange={(event, value) =>
                    this.setState({ salesStaff: value ? value.code : "" })
                  }
                  renderInput={(params) => (
                    <div ref={params.InputProps.ref}>
                      <input
                        type="text"
                        {...params.inputProps}
                        className="auto form-control Autocompletestyle-siteInfoSearch-employeeNo w100p"
                      />
                    </div>
                  )}
                />
              </InputGroup>
            </Col>
            {/* <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-sm">
                    年度
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  id="fiscalYear"
                  name="fiscalYear"
                  value={this.state.fiscalYear}
                  as="select"
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  onChange={this.yearAndMonthChange.bind(this)}
                />
              </InputGroup>
            </Col> */}
            
            <Col hidden>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-sm">
                    社員形式
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as="select"
                  size="sm"
                  onChange={this.valueChange}
                  name="employeeForms"
                  id="employeeForms"
                  value={employeeClassification === "1" ? "" : employeeForms}
                  autoComplete="off"
                  disabled={employeeClassification === "1" ? true : false}
                >
                  {employeeFormCodes.map((data) => (
                    <option key={data.code} value={data.code}>
                      {data.name}
                    </option>
                  ))}
                </Form.Control>
              </InputGroup>
            </Col>
            {/* <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-sm">
                    職種
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as="select"
                  size="sm"
                  onChange={this.valueChange}
                  disabled={
                    this.state.employeeClassification === "1" ? true : false
                  }
                  name="employeeOccupation"
                  id="employeeOccupation"
                  value={
                    this.state.employeeClassification === "1"
                      ? ""
                      : employeeOccupation
                  }
                  autoComplete="off"
                >
                  {occupationCodes.map((data) => (
                    <option key={data.code} value={data.code}>
                      {data.name}
                    </option>
                  ))}
                </Form.Control>
              </InputGroup>
            </Col> */}
          </Row>
          <Row>
            <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-sm">
                    単価範囲
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  name="utilPricefront"
                  id="utilPricefront"
                  value={this.state.utilPricefront}
                  onChange={(e) => this.vNumberChange(e, "utilPricefront")}
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder=" 万円"
                />
                <InputGroup.Prepend>
                  <InputGroup.Text className="width-auto bdr0">
                    ～
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  name="utilPriceback"
                  id="utilPriceback"
                  value={this.state.utilPriceback}
                  onChange={(e) => this.vNumberChange(e, "utilPriceback")}
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder=" 万円"
                />
              </InputGroup>
            </Col>
            <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text
                    id="inputGroup-sizing-sm"
                    style={{ width: "auto", whiteSpace: "nowrap", flexShrink: 0 }}
                  >
                    BP発注金額
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  name="salaryfront"
                  id="salaryfront"
                  value={this.state.salaryfront}
                  onChange={(e) => this.vNumberChange(e, "salaryfront")}
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder=" 万円"
                />
                <InputGroup.Prepend>
                  <InputGroup.Text className="width-auto bdr0">
                    ～
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  name="salaryback"
                  id="salaryback"
                  value={this.state.salaryback}
                  onChange={(e) => this.vNumberChange(e, "salaryback")}
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder=" 万円"
                />
              </InputGroup>
            </Col>
            <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-sm">
                    粗利範囲
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  name="grossProfitFront"
                  id="grossProfitFront"
                  value={this.state.grossProfitFront}
                  onChange={(e) => this.vNumberChange(e, "grossProfitFront")}
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder=" 万円"
                />
                <InputGroup.Prepend>
                  <InputGroup.Text className="width-auto bdr0">
                    ～
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  name="grossProfitBack"
                  id="grossProfitBack"
                  value={this.state.grossProfitBack}
                  onChange={(e) => this.vNumberChange(e, "grossProfitBack")}
                  aria-label="Small"
                  aria-describedby="inputGroup-sizing-sm"
                  placeholder=" 万円"
                />
              </InputGroup>
            </Col>
            <Col sm={3}>
              <InputGroup size="sm" className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-sm">
                    年月
                  </InputGroup.Text>
                  <DatePicker
                    selected={this.state.monthlySales_startYearAndMonth}
                    onChange={this.monthlySalesStartYearAndMonthChange}
                    autoComplete="off"
                    showMonthYearPicker
                    showFullMonthYearPicker
                    showDisabledMonthNavigation
                    className="form-control form-control-sm"
                    id="monthlysalesSearchDatePicker"
                    dateFormat={"yyyy/MM"}
                    name="individualSales_startYearAndMonth"
                    locale="ja"
                  ></DatePicker>
                  <InputGroup.Prepend>
                    <InputGroup.Text className="width-auto bdr0">
                      ～
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <DatePicker
                    selected={this.state.monthlySales_endYearAndMonth}
                    onChange={this.monthlySalesEndYearAndMonthChange}
                    autoComplete="off"
                    showMonthYearPicker
                    showFullMonthYearPicker
                    showDisabledMonthNavigation
                    className="form-control form-control-sm"
                    id="monthlysalesSearchDatePicker"
                    dateFormat={"yyyy/MM"}
                    name="individualSales_endYearAndMonth"
                    locale="ja"
                  ></DatePicker>
                </InputGroup.Prepend>
              </InputGroup>
            </Col>          
          </Row>
          <Row className="mb-3">
            <Col className="text-center">
              <Button
                variant="info"
                size="sm"
                id="shusei"
                onClick={this.searchMonthlySales}
              >
                <FontAwesomeIcon icon={faSearch} />
                検索
              </Button>{" "}
              <Button size="sm" variant="info" onClick={this.resetForm}>
                <FontAwesomeIcon icon={faUndo} /> Reset
              </Button>
            </Col>
          </Row>
        </Form>
        <Row>
          <div style={{ textAlign: "center" }}>
            {/* <Link
              to={{
                pathname: "/subMenuManager/individualSales",
                state: {
                  actionType: "monthly",
                  backPage: "monthlySalesSearch",
                  monthlySales_startYearAndMonth:
                    this.state.monthlySales_startYearAndMonth,
                  monthlySales_endYearAndMonth:
                    this.state.monthlySales_endYearAndMonth,
                  rowSelectemployeeNo: this.state.rowSelectemployeeNo,
                  rowSelectemployeeName: this.state.rowSelectemployeeName,
                  employeeClassification: this.state.employeeClassification,
                  employeeFormCodes: this.state.employeeFormCodes,
                  occupationCodes: this.state.occupationCodes,
                  kadou: this.state.kadou,
                  utilPricefront: this.state.utilPricefront,
                  utilPriceback: this.state.utilPriceback,
                  salaryfront: this.state.salaryfront,
                  salaryback: this.state.salaryback,
                  grossProfitFront: this.state.grossProfitFront,
                  grossProfitBack: this.state.grossProfitBack,
                  fiscalYear: this.state.fiscalYear,
                  employeeNo: this.state.rowSelectemployeeNo,
                  monthlyValue: {
                    monthlySales_startYearAndMonth:
                      this.state.monthlySales_startYearAndMonth,
                    monthlySales_endYearAndMonth:
                      this.state.monthlySales_endYearAndMonth,
                    utilPricefront: this.state.utilPricefront,
                    utilPriceback: this.state.utilPriceback,
                    salaryfront: this.state.salaryfront,
                    salaryback: this.state.salaryback,
                    grossProfitFront: this.state.grossProfitFront,
                    grossProfitBack: this.state.grossProfitBack,
                    fiscalYear: this.state.fiscalYear,
                    kadou: this.state.kadou,
                    employeeClassification: this.state.employeeClassification,
                    employeeOccupation: this.state.employeeOccupation,
                    rowNo: this.state.rowNo,
                  },
                },
              }}
              className="btn btn-info btn-sm disabled"
              id="personalSearchBtn"
            >
              {" "}
              個人情報
            </Link> */}
            <Button
              onClick={this.shuseiTo.bind(this, "detail")}
              size="sm"
              variant="info"
              name="clickButton"
              disabled={this.state.linkDisableFlag}
            >
              個人情報
            </Button>{" "}
            <font style={{ marginLeft: "2px", marginRight: "2px" }}></font>
            <Button
              hidden={this.state.authorityCode === "3"}
              size="sm"
              onClick={this.shuseiTo.bind(this, "siteInfo")}
              disabled={this.state.rowSelectemployeeNo === "" ? true : false}
              className="individualSalesButtom"
              name="clickButton"
              variant="info"
              id="siteInfo"
            >
              現場情報
            </Button>
          </div>
          <Col sm={9} style={{ marginLeft: "auto" }}>
            <Row className="justify-content-end flex-nowrap">
              <Col sm>
                <InputGroup size="sm">
                  <InputGroup.Prepend>
                    <InputGroup.Text
                      id="inputGroup-sizing-sm"
                      className="input-group-indiv"
                      style={{
                        backgroundColor: "#176b87",
                        color: "#ffffff",
                        fontFamily: "inherit",
                        fontWeight: 600,
                      }}
                    >
                      売上総額
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl
                    value={this.state.unitPirceTotal}
                    style={{
                      backgroundColor: "#e3f4fa",
                      color: "#154c63",
                      fontFamily: "inherit",
                      fontWeight: 600,
                    }}
                    disabled
                  />
                </InputGroup>
              </Col>
              <Col sm={4}>
                <InputGroup size="sm" className="flex-nowrap">
                  <InputGroup.Prepend>
                    <InputGroup.Text
                      className="input-group-indiv"
                      style={{ width: "auto", whiteSpace: "nowrap" }}
                    >
                      BP事業主売上総額
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl
                    value={this.state.bpBusinessSalesTotal}
                    style={{ minWidth: "8rem" }}
                    disabled
                  />
                </InputGroup>
              </Col>
          {this.state.authorityCode === "4" ?
            <>
              <Col sm>
                <InputGroup size="sm">
                  <InputGroup.Prepend>
                    <InputGroup.Text
                      id="inputGroup-sizing-sm"
                      className="input-group-indiv"
                    >
                      発注総額
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl value={this.state.salaryTotal} disabled />
                </InputGroup>
              </Col>
              {/* <Col>
                <InputGroup size="sm">
                  <InputGroup.Prepend>
                    <InputGroup.Text id="fiveKanji" className="input-group-indiv">
                      非稼働総額
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl value={this.state.TotalNonOperation} disabled />
                </InputGroup>
              </Col> */}
              <Col sm>
                <InputGroup size="sm">
                  <InputGroup.Prepend>
                    <InputGroup.Text
                      id="inputGroup-sizing-sm"
                      className="input-group-indiv"
                    >
                      粗利総額
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl value={this.state.grossProfitTotal} disabled />
                </InputGroup>
              </Col>
            </> : null}
            </Row>
          </Col>
        </Row>
        <div>
          <BootstrapTable
            data={this.state.monthlySalesInfoList}
            ref="monthlySalesInfoList"
            pagination={true}
            headerStyle={{ background: "#5599FF" }}
            selectRow={selectRow}
            options={{ ...this.options, page: this.state.currentPage }}
            striped
            hover
            condensed
          >
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              width="60"
              dataField="rowNo"
              isKey
              dataFormat={this.rowNoFormat}
            >
              番号
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="employeeName"
              dataFormat={this.employeeNameFormat}
              width="170"
            >
              氏名
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="lycStartYearAndMonth"
              dataFormat={this.lycStartYearAndMonthFormat}
              width="190"
            >
              LYCで稼働開始月
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="recentAdmissionStartDate"
                width="210"
                dataFormat={this.admissionStartDateFormat}
            >
                直近入場年月
            </TableHeaderColumn>
            <TableHeaderColumn
                tdStyle={{ padding: ".45em" }}
                dataField="customerName"
                width="150"
            >
                お客様
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="unitPrice"
              width="150"
              dataFormat={this.unitPriceAddComma}
            >
              単価
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="salary"
              width="150"
              dataFormat={this.salaryAddComma}
            >
              発注金額(BP単価)
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="monthlyGrosProfits"
              dataFormat={this.monthlyGrosProfitsAddComma}
              width="120"
            >
              粗利(税抜き)
            </TableHeaderColumn>
            <TableHeaderColumn
              tdStyle={{ padding: ".45em" }}
              dataField="salesStaffName"
              width="120"
            >
              営業担当
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    );
  }
}
export default monthlySalesSearch;
